module.exports = "pegasus_template/assets/icn_5.png";